"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.JsonHandler = exports.PlatformType = void 0;
var WebJsonLoader_1 = require("./WebJsonLoader");
var CordovaJsonLoader_1 = require("./CordovaJsonLoader");
var PlatformType;
(function (PlatformType) {
    PlatformType[PlatformType["Browser"] = 0] = "Browser";
    PlatformType[PlatformType["Mobile"] = 1] = "Mobile";
})(PlatformType = exports.PlatformType || (exports.PlatformType = {}));
var JsonHandler = /** @class */ (function () {
    function JsonHandler(path, type, onCompleteCallback) {
        switch (type) {
            case PlatformType.Mobile:
                this._parser = new CordovaJsonLoader_1.CordovaJsonLoader(path, onCompleteCallback.bind(this));
                break;
            case PlatformType.Browser:
                this._parser = new WebJsonLoader_1.WebJsonLoader(path, onCompleteCallback.bind(this));
                break;
            default:
                console.error("No valid JSON Handler found");
                break;
        }
    }
    JsonHandler.prototype.load = function () {
        this._parser.load();
    };
    return JsonHandler;
}());
exports.JsonHandler = JsonHandler;
